// extracted by mini-css-extract-plugin
export default {"table-container":"CallsTable_table-container__sgNN1","table-head":"CallsTable_table-head__AU+ho"};